import { render } from "./app-sidebar.vue?vue&type=template&id=52285666"
import script from "./app-sidebar.vue?vue&type=script&lang=js"
export * from "./app-sidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__